@if (displayValue() !== null) {
  <span
    class="bi-notification-badge"
    [class.bi-notification-badge--pending]="pendingMode()"
    [class.bi-notification-badge--standard]="!pendingMode()"
    [attr.aria-label]="ariaLabel()"
    >{{ displayValue() }}</span
  >
}
